<h2 (click)="bottomRef().close()">Einladung benötigt</h2>

<p>
  Unsere Discord-Gruppe benötigt im Interesse aller Mitglieder dieser Plattform eine Einladung 🕵️‍♂️
</p>

<p>Diese zu bekommen ist aber ganz einfach ☺️</p>

<p>Schreib uns eine Mail, auf Instagram oder Facebook um deine Einladung zu erhalten 🥳</p>
